export default __webpack_public_path__ + "static/media/Loading.6c211b7d.gif";